import { Fragment, HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import ParallaxImage from '@/components/base/parallax-image'
import { editorialVerticalGalleryRevealAnimation } from '@/components/sections/animations/editorial-vertical-gallery'
import Spacer from '@/components/sections/spacer'

import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

type EditorialVerticalGalleryProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    items: {
      type?: '1' | '2'
      image_1?: WPImage
      image_2?: WPImage
    }[]
  }>

const EditorialVerticalGallery = ({
  items,
  ...props
}: EditorialVerticalGalleryProps) => {
  return items && items.length > 0 ? (
    <Motion animation={editorialVerticalGalleryRevealAnimation}>
      {(motionRef) => (
        <Container
          ref={motionRef}
          className="bg-background-frame-dark"
          {...props}
        >
          <Spacer variant="xxl" />
          <Grid className="gap-y-[64px] md:gap-x-[100px] md:gap-y-[224px]">
            {items.map((item, index) => (
              <Fragment key={`item-${index}`}>
                <div
                  className={cn({
                    'col-span-2 md:col-span-6 lg:col-span-12':
                      item.type === '1',
                    'col-span-2 md:col-span-3 lg:col-span-6': item.type === '2'
                  })}
                >
                  {item.image_1 && (
                    <ParallaxImage
                      data-motion-media
                      style={{
                        aspectRatio: `${item.image_1.width} / ${item.image_1.height}`
                      }}
                      className={'relative flex h-full w-full'}
                    >
                      <img
                        src={item.image_1.url}
                        alt={item.image_1.alt}
                        className="h-auto w-full object-cover object-center"
                        data-lightbox
                      />
                    </ParallaxImage>
                  )}
                </div>
                {item.type === '2' && item.image_2 && (
                  <div className="col-span-2 md:col-span-3 lg:col-span-6">
                    <ParallaxImage
                      data-motion-media
                      style={{
                        aspectRatio: `${item.image_2.width} / ${item.image_2.height}`
                      }}
                      className={'relative flex h-full w-full'}
                    >
                      <img
                        src={item.image_2.url}
                        alt={item.image_2.alt}
                        className="h-auto w-full object-cover object-center"
                        data-lightbox
                      />
                    </ParallaxImage>
                  </div>
                )}
              </Fragment>
            ))}
          </Grid>
          <Spacer variant="xxl" />
        </Container>
      )}
    </Motion>
  ) : null
}

export default EditorialVerticalGallery
